<!-- stepper item for compressed stepper -->
<div class="d-flex flex-column justify-content-center align-items-center stepper-item-container" 
     *ngIf="this.getStepperVersion() === stepperType.Compressed">
    <div [ngClass]="{
        'stepper-compressed-content' : isMedium
    }">
        <div class="stepper-item-content-container">
            <div class="mt-4 text-center">
                <div *ngIf="this.getStepperItemImageType() !== stepperImageType.none && this.getStepperItemImageType() !== ''" class="stepper-image-container">
                    <object [data]="this.getStepperImage() | safeUrl" 
                            type="image/svg+xml"
                            [width]="this.iconWidth" [height]="this.iconHeight">
                    </object>
                </div>
                <h1 class="stepper-item-title">{{this.getTitle()}}</h1>
                <p class="stepper-item-description">{{this.getDescription()}}</p>
            </div>
            <div>
                <ng-container #embeddedView></ng-container>
            </div>
        </div>
        <!-- buttons -->
        <div class="mt-auto stepper-button-container">
    
            <div *ngIf="this.getIsDefaultStepperItem()" 
                 class="d-flex justify-content-center align-items-center">
                
                <button class="stepper-item-button back-button" 
                        (click)="this.onPrevButton()">
                        {{this.getPrevButtonText()}}
                </button>
                <button class="stepper-item-button next-button" 
                        (click)="this.onNextButton()">
                    {{this.getNextButtonText()}}
                </button>
            </div>
    
            <div *ngIf="this.getIsValidationStepperItem()" 
                 class="d-flex justify-content-center">
                <button class="stepper-item-button next-button button-validation-compressed" 
                        (click)="this.onNextButton()"
                        #validationBtnCompressed>
                    {{this.getValidationButtonText()}}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- stepper item for V3 and V4 -->
<div [class]="this.getViewCode() ? 'kt-wizard-v2__content' : 'tab-body'" 
     [attr.data-ktwizard-state]="this.getCurrentItem() ? 'current' : ''"
     data-ktwizard-type="step-content"
     *ngIf="this.getStepperVersion() === stepperType.V3 || this.getStepperVersion() === stepperType.V4">
     <ng-container #embeddedView></ng-container>
</div>

<!-- stepper item for full stepper -->
<div *ngIf="this.getStepperVersion() === stepperType.Full">

    <div [ngClass]="{
            'stepper-full-content-container-md': this.isMedium && !this.getIsStepperFullFullWidth(),
            'stepper-full-content-container-sm': this.isSmall && !this.getIsStepperFullFullWidth(),
            'stepper-full-content-container-xsm': this.isExtraSmall && !this.getIsStepperFullFullWidth(),
            'stepper-full-content-top-fixed': this.getIsStepperFullFixed() && !this.getIsStepperFullFullWidth(),
            'stepper-full-content-top-fixed-nf': this.getIsStepperFullFixed() && this.getIsStepperFullFullWidth() && !this.isExtraSmall,
            'stepper-full-content-top-fixex-xsm-nf': this.getIsStepperFullFixed() && this.getIsStepperFullFullWidth() && this.isExtraSmall,
            'stepper-full-content-top': !this.getIsStepperFullFixed()
        }" *ngIf="this.getStepperItemType() !== stepperItemTypeEnum.confirmation">
        <!-- header -->
        <div class="w-100 stepper-item-full-container" *ngIf="this.getTitle() || this.getDescription()">
            <h1 class="bs-h1 th-text-main">{{this.getTitle()}}</h1>
            <span class="bs-paragraph th-text-gray-paragraphs">{{this.getDescription()}}</span>
        </div>
    
        <!-- content -->
        <ng-container #embeddedView></ng-container>
    </div>

    <div *ngIf="this.getStepperItemType() === stepperItemTypeEnum.confirmation"
         [ngClass]="{
            'stepper-full-content-conf-md': this.isMedium,
            'stepper-full-content-conf-sm': this.isSmall,
            'stepper-full-content-conf-xsm': this.isExtraSmall
        }"
        class="d-flex justify-content-center w-100">

        <div class="confirmation-stepper-item pt-5 pb-5 ps-2 pe-2 d-flex flex-column align-items-center justify-content-center th-bg-white">
            <object [data]="this.getStepperImage() | safeUrl" 
                   type="image/svg+xml"
                   [width]="this.iconWidth" [height]="this.iconHeight">
           </object>
           <h1 class="stepper-item-title text-center mt-4">{{this.getTitle()}}</h1>
           <p class="stepper-item-description text-center">{{this.getDescription()}}</p>
           <!-- content -->
           <ng-container #embeddedView></ng-container>

           <!-- buttons -->
           <div class="w-100 mt-5">
            <div class="d-flex justify-content-center gap-3" 
                [class.d-none]="this.isExtraSmall">
                <div [class.d-none]="this.getPrevButtonText() === ''">
                    <ng-container #prevButton></ng-container>
                </div>
                <div [class.d-none]="this.getNextButtonText() === ''">
                    <ng-container #nextButton></ng-container>
                </div>
            </div>
            <div [class.d-none]="!this.isExtraSmall" class="d-flex w-100">
                <div class="w-50 p-2" [ngClass]="{
                    'd-none' : this.getPrevButtonText() === '',
                    'w-50': this.getNextButtonText() !== '' && this.getPrevButtonText() !== '',
                    'w-100': this.getNextButtonText() === '' && this.getPrevButtonText() !== ''
                }">
                    <ng-container #prevButtonXS></ng-container>
                </div>
                <div class="w-50 p-2" [ngClass]="{
                    'd-none' : this.getNextButtonText() === '',
                    'w-50': this.getNextButtonText() !== '' && this.getPrevButtonText() !== '',
                    'w-100': this.getNextButtonText() !== '' && this.getPrevButtonText() === ''
                }">
                    <ng-container #nextButtonXS></ng-container>
                </div>
            </div>
           </div>
        </div>
    </div>

    <!-- options -->
    <div class="stepper-full-options-bar-container th-bg-white"
        [ngClass]="{
            'position-fixed bottom-0': this.getIsStepperFullFixed()
        }" 
        *ngIf="this.getStepperItemType() !== stepperItemTypeEnum.confirmation">

        <!-- for medium and small screens -->
        <div class="stepper-full-options-bar d-flex justify-content-between align-items-center"
            [ngClass]="{
                'medium-bar-spacing': this.isMedium,
                'small-bar-spacing': this.isSmall
            }" *ngIf="!this.isExtraSmall">
            <div class="w-50">
                <ng-container #prevButton></ng-container>
            </div>
            <div class="w-50 d-flex justify-content-end">
                <div class="pe-3 d-flex flex-column text-end" 
                     *ngIf="this.getFooterDescription() && (this.getFooterDescriptionValue() || this.getFooterDescriptionValue() === 0)">
                    <span class="bs-h3 th-text-gray-paragraphs">
                        {{this.getFooterDescription()}}
                    </span>
                    <span class="bs-h1 th-text-main">
                        {{!this.getIsFooterDescriptionCurrency() ? this.getFooterDescriptionValue() : 
                            (this.getFooterDescriptionValue() | currency: this.getFooterDescriptionCurrency():'symbol-narrow')}}
                    </span>
                </div>
                <ng-container #nextButton></ng-container>
            </div>
            <!-- <ng-container #prevButton></ng-container>
            <ng-container #nextButton></ng-container> -->
        </div>

        <!-- for extrasmall screens -->
        <div class="stepper-full-options-bar"
            *ngIf="this.isExtraSmall">

            <div class="w-100 pt-3"
                *ngIf="this.getFooterDescription() && (this.getFooterDescriptionValue() || this.getFooterDescriptionValue() === 0)">
                <div class="ps-2 pe-2 d-flex align-items-center w-100">
                    <span class="bs-h3 th-text-gray-paragraphs">
                        {{this.getFooterDescription()}}
                    </span>
                    <span class="ms-auto bs-h1 th-text-main">
                        {{!this.getIsFooterDescriptionCurrency() ? this.getFooterDescriptionValue() : 
                            (this.getFooterDescriptionValue() | currency: this.getFooterDescriptionCurrency():'symbol-narrow')}}
                    </span>
                </div>
            </div>

            <div class="mt-2 d-flex align-items-center">
                <div class="w-50 p-2">
                    <ng-container #prevButtonXS></ng-container>
                </div>
                <div class="w-50 p-2">
                    <ng-container #nextButtonXS></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>